import { EditOutlined, SaveOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import React from 'react'

export function EditSectionHeader({ title, editing, onEdit, onSubmit }) {
  return (
    <Horizontal
      verticalCenter
      justifyContent={'space-between'}
      className={'full-height-width px-3 border-bottom '}
      style={{ backgroundColor: 'var(--theme-color-2-dim)' }}
    >
      <Texto textTransform={'uppercase'} style={{ color: 'var(--gray-700)' }}>
        {title}
      </Texto>
      <GraviButton
        icon={editing ? <SaveOutlined /> : <EditOutlined />}
        onClick={() => (editing ? onSubmit() : onEdit())}
        className='ml-3 ghost-gravi-button'
      />
    </Horizontal>
  )
}
